import z from "zod";

import { REGEX } from "../zod.regex";

export type ContactSchema = z.infer<typeof Contact>;

export const Contact = z
  .object({
    name: z.string().nonempty({ message: "Nome é obrigatório" }),
    email: z
      .preprocess(
        (value = "") => {
          if (value === null || value === undefined) return value;
          return typeof value === "string" ? value.trim() : value;
        },
        z.union([z.email({ message: "Email inválido" }), z.literal("")])
      )
      .optional()
      .nullable(),
    phone: z
      .preprocess(
        (value) => {
          if (value === null || value === undefined) return value;
          if (typeof value === "string") return value.replace(/\s+/g, "");
          return value;
        },
        z.union([z.string().regex(REGEX.PHONE, { message: "Telefone inválido" }), z.literal("")])
      )
      .optional()
      .nullable(),
    whatsapp: z
      .preprocess(
        (value) => {
          if (value === null || value === undefined) return value;
          if (typeof value === "string") return value.replace(/\s+/g, "");
          return value;
        },
        z.union([z.string().regex(REGEX.PHONE, { message: "WhatsApp inválido" }), z.literal("")])
      )
      .optional()
      .nullable()
  })
  .partial();
